import { HomeIcon } from '@popsure/dirty-swan';
import ButtonCell from 'components/buttonCell';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useSafeTranslation } from 'shared/i18n';

import { PolicyDetailsButtonProps } from '../../sections/PolicyDetails/PolicyDetails.models';

dayjs.extend(isSameOrAfter);

export const UpdateAddressButton = (props: PolicyDetailsButtonProps) => {
  const {
    onOpenModal,
    policyData: {
      status,
      attributes: { adjustmentDate },
    },
  } = props;
  const { t } = useSafeTranslation();

  return (
    <ButtonCell
      title={t(
        'myPolicies.policyDetails.updateAddressButton.caption',
        'Update my address'
      )}
      icon={<HomeIcon noMargin size={24} className="ml16" />}
      onClick={() => onOpenModal('UPDATE_ADDRESS')}
      disabled={Boolean(
        status === 'ACTIVE' &&
          adjustmentDate &&
          !dayjs().isSameOrAfter(adjustmentDate)
      )}
    />
  );
};
